import {
  PixLogoIcon,
  BarcodeIcon,
  CreditCardIcon,
} from "@phosphor-icons/react";
import type { ComponentType } from "react";
import type { IconProps } from "@phosphor-icons/react";

export const ACCORDION_IDS = {
  PIX: "pix",
  DEBIT: "debit",
  CREDIT: "credit",
  BANK_SLIP: "bankSlip",
  RECEIPT_TYPE: "receiptType",
} as const;

export const METHOD_ACCORDION_CONFIG: Array<{
  id: string;
  icon: ComponentType<IconProps>;
  titleKey: string;
  diffKey: "pix" | "debit" | "credit" | "bankSlip";
}> = [
  {
    id: ACCORDION_IDS.PIX,
    icon: PixLogoIcon,
    titleKey: "payfac.pageRatePlanDetailsPix",
    diffKey: "pix",
  },
  {
    id: ACCORDION_IDS.DEBIT,
    icon: CreditCardIcon,
    titleKey: "payfac.pageRatePlanDetailsDebitCard",
    diffKey: "debit",
  },
  {
    id: ACCORDION_IDS.CREDIT,
    icon: CreditCardIcon,
    titleKey: "payfac.pageRatePlanDetailsCreditCard",
    diffKey: "credit",
  },
  {
    id: ACCORDION_IDS.BANK_SLIP,
    icon: BarcodeIcon,
    titleKey: "payfac.pageRatePlanDetailsBoleto",
    diffKey: "bankSlip",
  },
];
